import { ActionTypes } from '../actions/app'

import { ActionTypes as AuthActions } from '../actions/authentication'

const initialState = {
  initialized: false,
}

export const app = (state = initialState, action) => {
  switch (action.type) {
    case AuthActions.AUTHENTICATION_LOGIN:
      return Object.assign({}, state, action.user, { initialized: true })
    case AuthActions.AUTHENTICATION_LOGOUT:
      return Object.assign({}, initialState)

    case ActionTypes.APP_INITIALIZING:
      return Object.assign({}, state, { initialized: false })

    case ActionTypes.APP_INITIALIZED:
      return Object.assign({}, state, action.config, { initialized: true })

    default:
      return state
  }
}

export default app
